import img from "../Images/Saral_eway_dash.png"
const eWayBillFeatures = {
    featureTitle :"Track, Extend, Stop, and Recharge",
    featureDescription:"Saral Way is an advanced, automated solution designed to streamline e-way bill operations, ensuring compliance and efficiency. It offers the following key features",
    featureLists : [
        {
          title: "Track Expiring E-Way Bills",
          description: "Get real-time updates on e-way bills expiring today for timely action."
        },
        {
          title: "Automatic & Manual Extensions",
          description: "Extend e-way bills instantly, reducing manual work and compliance risks."
        },
        {
          title: "Stop & Restart Specific E-Way Bills",
          description: "Gain full control by pausing or reactivating e-way bills as needed."
        },
        {
          title: "E-Way Bill Copy Printing",
          description: "Quickly download and print e-way bills for documentation and verification."
        },
        {
          title: "Aadhaar & PAN Linking Status",
          description: "Check the status of Aadhaar and PAN linking for compliance purposes."
        },
        {
          title: "Generate Consolidated E-Way Bills",
          description: "When multiple e-way bills are assigned to a single vehicle, Saral Way generates a consolidated e-way bill for streamlined transportation."
        },
        {
          title: "Transfer E-Way Bills to Another Transporter",
          description: "Easily reassign e-way bills to a new transporter when needed."
        },
        {
          title: "Track E-Way Bill Usage",
          description: "View e-way bill counts based on recharge and plans: Allowed E-Way Bill Count - The total e-way bills available as per the plan. Current E-Way Bill Count - The number of e-way bills used, helping transporters track their remaining quota."
        },
        {
          title: "Direct Recharge Facility",
          description: "Recharge within the software for uninterrupted service."
        }
      ]
}

const whyChoose = {
  title:"Why Choose",
  title_h:"Saral Way?",
  description:"Managing e-way bills can be time-consuming and complex, but Saral Way makes it effortless with automation and smart tracking. Here’s why Saral Way is the best choice for your e-way bill management.",
  lists: [
    {
      title: "Automatic E-Way Bill Extension",
      description: "Auto-extend e-way bills to save time and reduce errors."
    },
    {
      title: "Real-Time Status & Insights",
      description: "Track expiring, extended, and in-transit e-way bills."
    },
    {
      title: "Easy Recharge & Usage Tracking",
      description: "Monitor your quota and recharge directly in the software."
    },
    {
      title: "Hassle-Free Compliance",
      description: "Stay compliant with GST rules and easy Aadhaar-PAN linking."
    },
    {
      title: "Bulk Operations & Consolidation",
      description: "Generate consolidated e-way bills for multiple shipments."
    },
    {
      title: "Trusted by 35+ Businesses",
      description: "Join transporters relying on Saral Way for efficiency."
    }
  ]
   ,
  img:img
};

  
export {eWayBillFeatures, whyChoose}  